import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import compose from 'lodash.flowright';
import { useApolloClient } from 'react-apollo';

import Spinner from '../../global/Spinner';
import useDiscoverAlbumFolderPrintPackages from './hooks/useDiscoverAlbumFolderPrintPackages';
import useOpenModal from '../../../hooks/useOpenModal';
import useCloseModal from '../../../hooks/useCloseModal';
import { gtm } from '../../../util/analytics';
import Angle from '../../global/Angle';
import Button from '../../global/Button';
import getConfig from '../../../util/config';
import { CHECKOUT_CART_MODAL } from '../../../services/checkout/components/CheckoutCart/modal';
import { CheckoutCartModal } from '../../../services/checkout/components/CheckoutCart';
import PrepaidPrintPackagesPurchase from '../../global/PrepaidPrintPackagesPurchaseModal/PrepaidPrintPackagesPurchase';

const propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      albumFolderId: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};

const DiscoverAlbumFolderPrintPackages = ({ history, match, location }) => {
  const { albumFolderId } = match.params;
  const client = useApolloClient();
  const {
    user,
    loading,
    activePromoCode,
  } = useDiscoverAlbumFolderPrintPackages({
    albumFolderId,
  });

  const config = getConfig();
  const openModal = useOpenModal();
  const closeModal = useCloseModal();
  const { baseUrl } = config.app ?? {};

  if (loading || !user) {
    return (
      <div className="w-100 h-100vh d-flex align-items-center justify-content-center">
        <Spinner />
      </div>
    );
  }

  return (
    <Fragment>
      <Button
        btnStyle="link"
        className="prepaid-print-packages-return"
        onClick={() => {
          history.push(
            `/purchase/album-folder/${albumFolderId}/purchase-subscription`,
          );
        }}
      >
        <Angle direction="left" /> <span className="ml-1">Back</span>
      </Button>
      <PrepaidPrintPackagesPurchase
        albumFolderId={albumFolderId}
        onCheckout={() => {
          gtm.trackPageView({
            url: `${baseUrl}${location.pathname}/virtual/payment`,
            title: 'Virtual Pageview - Payment',
            userId: user.id,
          });

          openModal(CHECKOUT_CART_MODAL, {
            onSuccess: () => {
              history.replace(
                `/discover/album-folder/${albumFolderId}/success`,
              );
            },
          });
        }}
        onAddFace={() =>
          history.push(`/discover/album-folder/${albumFolderId}/faces`)
        }
      />
      <CheckoutCartModal
        onSuccess={() => {
          // We gotta nuke everything until we can find a way to clear
          // only the relevant data that need clearing (i.e. AlbumMembershipGroup
          // and purchases, purchased custom prints, etc).
          client.resetStore();
          closeModal(CHECKOUT_CART_MODAL);
          history.replace(`/discover/album-folder/${albumFolderId}/success`);
        }}
        stripeModalProps={{
          defaultPromoCode: activePromoCode?.code ?? '',
          description: (
            <Fragment>
              <p className="text-center">Checkout</p>
              {activePromoCode && (
                <p className="text-extra-bold text-center">
                  Promo code: {activePromoCode.code}
                </p>
              )}
            </Fragment>
          ),
        }}
      />
    </Fragment>
  );
};

DiscoverAlbumFolderPrintPackages.propTypes = propTypes;

export default compose(withRouter)(DiscoverAlbumFolderPrintPackages);
